module.exports = __webpack_public_path__ + "static/HERMES_robot-7a0a8389fc57b3e9136248424dcacc20.jpg";